import { createSelector } from 'reselect'

export const getServices = createSelector(
  state => state && state.ads && state.ads.services && Array.isArray(state.ads.services.elements)
    ? state.ads.services.elements : [],
  services => services
)
